import React from 'react';
import { connect } from 'react-redux';
import VisitPhotos from './VisitPhotos';
import { UPLOAD_ACCOUNT_FILE } from '../../../constants/index';
import { PostVisitSummarySagaActions } from '../../../sagas/postVisitSummary';

const mapStateToProps = (state: any, ownProps: any) => ({
  booking: state.account.booking,
  bookingImages: state.bookingImages[ownProps.booking.id],
  sessionTrackingProperties: state.sessionTrackingProperties,
});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  fetchBookingImages: () => {
    const { booking } = ownProps;
    dispatch({
      accountId: booking.account_id,
      bookingId: booking.id,
      type: PostVisitSummarySagaActions.FETCH_IMAGES,
      userProfileId: booking.user_profile_id,
    });
  },

  saveFile: (file: any) => {
    const { accountId, booking, userProfileId } = ownProps;
    dispatch({
      accountId,
      bookingId: booking.id,
      file,
      type: UPLOAD_ACCOUNT_FILE,
      userProfileId,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VisitPhotos);
